import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Ng2ImgMaxService } from 'ng2-img-max';

import { ToasterService } from '../../_services/toaster.service';
import {ActivatedRoute, Router} from '@angular/router';
import {AuthenicationService} from '../../_services/authenication.service';
import {DoctorService} from '../../_services/doctor.service';
import {UserService} from '../../_services/user.service';
import {first} from 'rxjs/operators';
import {DynamicScriptLoaderServiceService} from "../../_services/dynamic-script-loader-service.service";
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';

@Component({
  selector: 'app-adddoctor',
  templateUrl: './adddoctor.component.html',
  styleUrls: ['./adddoctor.component.css']
})
export class AdddoctorComponent implements OnInit {

  addDocForm: FormGroup;
  submitted = false;
  returnUrl: string;
  selectedfile: File = null;
  selectedfile1: Array<File> = [];
  userdetaild: string;
  imgtype = 'image/*';
  png = 'image/png';
  jpg = 'image/jpg';
  jpeg = 'image/jpeg';
  doc = 'application/msword';
  docx = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
  pdf = 'application/pdf';

  users: [];
  msgcode: string;

  isShown: boolean = false ; // hidden by default
  isShown1: boolean = false ; // hidden by default


  // tslint:disable-next-line:max-line-length
  constructor(private formBuilder: FormBuilder, private router: Router, private route: ActivatedRoute, private toaster: ToasterService, private authenicationService: AuthenicationService, private userservice: UserService, private doctorservice: DoctorService, private spinnerService: Ng4LoadingSpinnerService, private ng2ImgMax: Ng2ImgMaxService) { }

  ngOnInit() {
    // console.log(this.userdetaild = this.authenicationService.userDetails());

    // DynamicScriptLoaderServiceService.adminScripts();

    this.userdetaild = this.authenicationService.userDetails();
    if (!this.userdetaild) {
      this.router.navigate(['/login']);
    }

    // if (!this.userdetaild || this.userdetaild['users_usertype'] !== 'admin') {
    //   this.authenicationService.logout();
    //   this.router.navigateByUrl('/login');
    // }

    if (!this.userdetaild || this.userdetaild['users_usertype'] == 'employee2') {
      this.router.navigate(['/']);
    }

    DynamicScriptLoaderServiceService.loadDynamicScript('assets/assets/dist/js/selectpicker.js');

    this.addDocForm = this.formBuilder.group({
      users_name: ['', [Validators.required, Validators.minLength(3)]],
      users_email: ['', [Validators.required, Validators.email]],
      users_password: ['', [Validators.required, Validators.minLength(3)]],
      photo: [''],
      users_mobile: ['', [Validators.required]],
      users_city: ['', [Validators.required]],
      // users_usertype: ['doctor', [Validators.required]],
      users_status: ['true', [Validators.required]],
      degree: ['', [Validators.required]],
      mental_health_prof: ['', [Validators.required]],
      experience: ['', [Validators.required, Validators.min(1), Validators.maxLength(2)]],
      language: ['', [Validators.required]],
      gender: ['', [Validators.required]],
      about: ['', [Validators.required]],
      speciality: ['', [Validators.required]],
      certificates: ['',[Validators.required]],
      session_mode: ['', [Validators.required]],
      own_space: ['N/A', [Validators.required]],
      space_address: ['N/A', [Validators.required]],
    });
    //this.setConditionalValidation();

    this.returnUrl = this.route.snapshot.queryParams.returnUrl || '/';
  }

  get f() { return this.addDocForm.controls; }

  fileUpload(event) {
    let image = event.target.files[0];
    if (image.type === this.jpg || image.type === this.png || image.type === this.jpeg) {
      //this.addDocForm.controls['photo'].setValue(this.selectedfile ? this.selectedfile : '');

      this.ng2ImgMax.compressImage(image, 1, true).subscribe(
        result => {
          this.selectedfile = result;
        },
        error => {
          console.log(JSON.stringify(error));
          this.toaster.showError('😢 Oh no!', error);
        }
      );
      return true;
    } else {
      this.addDocForm.controls.photo.reset();
      this.toaster.showError('File Type', 'Only Images are allowed');
      return false;
    }
  }

  fileUpload1(event) {
    this.selectedfile1 = event.target.files as Array<File>;
    for (let i = 0; i < this.selectedfile1.length; i++) {
      if (this.selectedfile1[i].type === this.doc || this.selectedfile1[i].type === this.docx || this.selectedfile1[i].type === this.pdf) {
        this.addDocForm.controls.certificates.clearValidators();
        return true;
      } else {
        this.addDocForm.controls.certificates.reset();
        this.toaster.showError('File Type', 'Only Documents are allowed');
        return false;
      }
    }
  }



  // setConditionalValidation() {
  //   const own_space = this.addDocForm.get('own_space');
  //   const space_address = this.addDocForm.get('space_address');
  //
  //   this.addDocForm.get('session_mode').valueChanges
  //     .subscribe(session_mode => {
  //       if (session_mode === 'yes') {
  //         own_space.setValidators([Validators.required]);
  //         space_address.setValidators(null);
  //       }
  //     });
  //   this.addDocForm.get('own_space').valueChanges
  //     .subscribe(own_space => {
  //       if (own_space === 'yes') {
  //         space_address.setValidators([Validators.required]);
  //       }
  //     });
  //   own_space.updateValueAndValidity();
  //   space_address.updateValueAndValidity();
  // };


  toggleShow() {

    this.isShown = ! this.isShown;

  }

  toggleShow1() {

    this.isShown1 = ! this.isShown1;

  }


  onSubmit() {
    this.submitted = true;
    this.spinnerService.show();
    // stop here if form is invalid
    if (this.addDocForm.invalid) {
      this.spinnerService.hide();
      return;
    }

    const addUserPayload = {
      users_name: this.addDocForm.controls.users_name.value,
      users_email: this.addDocForm.controls.users_email.value,
      users_mobile: this.addDocForm.controls.users_mobile.value,
      users_city: this.addDocForm.controls.users_city.value,
      users_password: this.addDocForm.controls.users_password.value,
      users_status: this.addDocForm.controls.users_status.value,
      users_usertype: 'doctor'
    };

    const addDoctorPayload = {
      degree: this.addDocForm.controls.degree.value.toString(),
      mental_health_prof: this.addDocForm.controls.mental_health_prof.value.toString(),
      experience: this.addDocForm.controls.experience.value,
      about: this.addDocForm.controls.about.value,
      gender: this.addDocForm.controls.gender.value,
      language: this.addDocForm.controls.language.value.toString(),
      speciality: this.addDocForm.controls.speciality.value.toString(),
      session_mode: this.addDocForm.controls.session_mode.value,
      own_space: (this.addDocForm.controls.own_space.value)?this.addDocForm.controls.own_space.value:'N/A',
      space_address: (this.addDocForm.controls.space_address.value)?this.addDocForm.controls.space_address.value:'N/A',
    };

    const formdata = new FormData();

    formdata.append('users_name', addUserPayload.users_name);
    formdata.append('users_email', addUserPayload.users_email);
    formdata.append('users_mobile', addUserPayload.users_mobile);
    formdata.append('users_city', addUserPayload.users_city);
    formdata.append('users_password', addUserPayload.users_password);
    formdata.append('users_status', addUserPayload.users_status);
    formdata.append('users_usertype', addUserPayload.users_usertype);
    if (this.selectedfile !== null) {
      formdata.append('photo', this.selectedfile);
    }


    this.addUser(formdata, addDoctorPayload, this.selectedfile1);

  }

  addUser(payload, payload1, certificatefile) {
    this.userservice.addUser(payload)
      .pipe(first())
      .subscribe(
        (data: any) => {
          if (data && data.ResponseCode === '200') {

            const formdata = new FormData();
            formdata.append('docid', data.UserData._id);
            formdata.append('degree', payload1.degree);
            formdata.append('mental_health_prof', payload1.mental_health_prof);
            formdata.append('experience', payload1.experience);
            formdata.append('gender', payload1.gender);
            formdata.append('about', payload1.about);
            formdata.append('language', payload1.language);
            formdata.append('speciality', payload1.speciality);
            if (this.selectedfile1) {
              const files: Array<File> = certificatefile;
              for (let i = 0; i < files.length; i++) {
                formdata.append('certificates', files[i], files[i].name);
              }
            }
            formdata.append('session_mode', payload1.session_mode);
            formdata.append('own_space', payload1.own_space);
            formdata.append('space_address', payload1.space_address);

            this.addDoctor(formdata);

          } else {
            this.toaster.showError('Add Doctor', data.ResponseMessage);
            this.msgcode = data.ResponseCode;
          }
          // this.router.navigate([this.returnUrl]);
        },
        error => {
          this.toaster.showError('Add Doctor', error.error.ResponseMessage);
          this.msgcode = error.error.ResponseCode;
        });
  }

  addDoctor(payload) {
    this.doctorservice.addDoctor(payload)
      .pipe(first())
      .subscribe(
        (data: any) => {
          if (data && data.ResponseCode === '200') {
            //this.toaster.showSuccess('Add Doctor', data.ResponseMessage);
            this.router.navigate(['/doctorlist']);
          } else {
            this.toaster.showError('Add Doctor', data.ResponseMessage);
          }
          // this.router.navigate([this.returnUrl]);
        },
        error => {
          this.toaster.showError('Add Doctor', error.error.ResponseMessage);
        });
  }


}
